import {useEffect} from 'react'

import {hideAlert} from '../../../infra/utils/alerts'

export const withTimer = Component => {
  const ComponentWithTimer = ({duration, id, ...props}) => {
    useEffect(() => {
      if (duration) {
        const timer = setTimeout(() => {
          hideAlert(id)
        }, duration)

        return () => clearTimeout(timer)
      }
    }, [id, duration])

    return <Component {...props} id={id} />
  }

  return ComponentWithTimer
}
